import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'
import JumpPage from '@/views/JumpPage.vue'
import NewHome from '@/views/NewHome.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'HomePage',
    component: NewHome,
    // component: HomePage,
  },
  // （可选）添加根路径重定向到 /home
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/jump',
    name: 'jumpPage',
    component: JumpPage
  },
  {
    path: '/newHome',
    name: 'NewHomePage',
    component: NewHome
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
